// extracted by mini-css-extract-plugin
export var chevronIcon = "_s9-1";
export var edgeToggle = "_s9-0";